<template>
  <div>
    <b-modal
      id="nextStage_3_confirm"
      :title="showAlertTitle"
      centered
      @ok="onNextStage"
      ok-title="확인"
      cancel-title="취소"
      @hide="receiptPrecessWorking = false"
    >
      <div class="bg-white p-3 rounded box-shadow">
        <p class="text-muted mb-0">
          총 {{ revConfirmList.length }}건의 일정 접수를 완료 하시겠습니까?<br />확인 클릭 후, 마이페이지에서
          {{ getListType }}
          내역 확인 바랍니다.
        </p>
        <div style="font-size: 0.8rem; color: #555555; margin-top: 1rem" v-show="listType === 'RECEIPT'">
          ※ 접수 배정 결과 확인 : 차주 화요일 13시 홈페이지<br />
          ※ SMS 수신 체크된 확정 건만 알림톡 발송 <br />
          ※ 선착순 배정이 아니며, 변경 사항이 있을 시 기존 접수 내역 취소 후 17:00 까지 재접수
        </div>
        <div style="font-size: 0.8rem; color: #555555; margin-top: 1rem" v-show="listType === 'WAIT'">
          ※ 접수 후 배정 여부는 개별 알림톡으로 안내 (예약 마감 안내 포함)<br />
          ※ SMS 수신 체크된 연락처로만 알림톡 발송 <br />
          ※ 선착순 배정으로, 접수 내역 취소 시 접수 순번 초기화 (후순위로 변경)
        </div>
      </div>
    </b-modal>
    <div class="stageContainer">
      <ReceiptSummary :list-type="listType" :rev-confirm-list="revConfirmList" />
      <div class="buttonGroup">
        <button class="moveButton" @click="prevStage()">
          <span>이전</span>
        </button>
        <button class="moveButton" @click="nextStage()" :disabled="receiptPrecessWorking">
          <span>완료</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptSummary from '@/pages/RevReceiptPage/Component/ReceiptSummary';
import reserveService from '@/services/rev.service';
import moment from 'moment';
import GeneralUtil from '@/util/GeneralUtil';
import {getReservText} from '@/util/GolfUtil';
export default {
  name: 'RegStage3',
  mixins: [GeneralUtil],
  components: {ReceiptSummary},
  props: {
    listType: String,
    revConfirmList: Array,
  },
  data() {
    return {
      receiptPrecessWorking: false,
      showAlertTitle: '사전접수 완료',
      errMessage: '',
    };
  },
  computed: {
    getListType() {
      return getReservText(this.listType);
    },
  },
  mounted() {
    this.showAlertTitle = `${this.getListType} 완료`;
  },
  methods: {
    getRndInteger(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },

    async onNextStage() {
      //this.$EventBus.$emit('NextStage');
      // console.log(this.revConfirmList, this.revConfirmList[0].toApiModel());
      try {
        this.showLoadingModal();
        let receipt_actionkey = `${moment().valueOf()}_${this.getRndInteger(1000000000, 9999999999)}`;
        for (const x of this.revConfirmList) {
          console.log('xxxx', x);
          if (this.listType === 'REAL') {
            let dtoList = x.toApiRealModel();
            for (const dto of dtoList) {
              let result = await reserveService.receiptNew(this.listType, dto);
              if (result.resultCode !== '0000') {
                await this.showMsgBoxOkPmsErr(result.msg);
              }
            }
          } else {
            let dtoList = x.toApiReceiptModel();
            for (let i = 0; i < dtoList.length && this.errMessage == ''; i++) {
              const dto = dtoList[i];
              // G102 API 수정됨
              //사전접수,잔여접수시 여러개일 경우 actionKey 를 생성하여 같은 접수 건임을 PMS에게 알려준다.
              if (this.listType === 'RECEIPT' || this.listType === 'WAIT') dto.actionKey = receipt_actionkey;
              let result = await reserveService.receiptNew(this.listType, dto);
              if (result.resultCode !== '0000') {
                this.errMessage = result.msg;
                await this.showMsgBoxOkPmsErr(result.msg);
                this.$EventBus.$emit('GoRootPage');
                break;
              }
            }
            // if (errMessage !== '') {
            //   await this.showMsgBoxOkPmsErr(errMessage);
            //   this.$router.replace('/');
            // }
          }
        }

        this.$EventBus.$emit('NextStage');
      } finally {
        this.hideLoadingModal();
      }
    },

    nextStage() {
      if (!this.receiptPrecessWorking) {
        this.receiptPrecessWorking = true;
        this.$bvModal.show('nextStage_3_confirm');
      }
    },

    prevStage() {
      this.$EventBus.$emit('PrevStage');
    },
  },
};
</script>

<style scoped lang="scss">
.stageContainer {
  width: 100%;
}
.buttonGroup {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1rem;
  width: 30%;
  .moveButton {
    display: inline-flex;
    align-items: center;
    height: 2.3rem;
    font-size: 0.8rem;
    width: 100%;
    margin: 1rem;

    background-color: #524a3d !important;
    padding: 0px !important;
    color: white;
    border: none;
    outline: none;
    span {
      padding: 0px;
      width: 100%;
      text-align: center;
      padding: 0px !important;
    }
    &:hover {
      background-color: #403a30 !important;
    }
  }
}
@media (max-width: 992px) {
  .buttonGroup {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
    width: 100%;
    .moveButton {
      display: inline-flex;
      align-items: center;
      height: 2.3rem;
      font-size: 0.8rem;
      width: 100%;
      margin: 1rem;

      background-color: #524a3d !important;
      padding: 0px !important;
      color: white;
      border: none;
      outline: none;
      span {
        padding: 0px;
        width: 100%;
        text-align: center;
        padding: 0px !important;
      }
      &:hover {
        background-color: #403a30 !important;
      }
    }
  }
}
</style>
